import React from 'react';
import { UnlayerDocumentTemplatesView } from '@/components/views/UnlayerDocumentTemplatesView';

export const UnlayerDocumentTemplatesPage = () => {
	return <UnlayerDocumentTemplatesView />;
};
